import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=24b3eb4c&"
import script from "./TabsComponent.vue?vue&type=script&lang=js&"
export * from "./TabsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports